export default __webpack_public_path__ + "static/media/harmonylogo.13a9248a.svg";